import styled from "@emotion/styled";
import { Icon, Theme, Typography, useTheme } from "@yuno/design-system-web";
import { useContext } from "react";
import { ThemeContext } from "../../../../context/theme-context";
import { CustomTheme } from "../../../../types/custom-theme";

const Container = styled.div<{
  theme?: Theme;
  customTheme: CustomTheme;
  isLast?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid
    ${({ customTheme, isLast }) =>
      isLast ? "none" : customTheme.payment_form.container.edge_color};
  padding-bottom: 16px;
  margin-top: 16px;

  p {
    color: ${({ customTheme }) => customTheme.payment_form.settings.font_color};
    font-size: ${({ customTheme }) =>
      customTheme.payment_form.settings.font_size}px !important;
    font-weight: ${({ customTheme }) =>
      customTheme.payment_form.settings.font_weight};
  }

  .left,
  .right {
    display: flex;
    align-items: center;
  }

  img {
    width: 30px;
    height: 30px;
  }

  .left p {
    margin-left: 16px;
    font-size: ${({ theme }) => theme.typography.small.regular.fontSize};
  }

  .right .tools {
    display: flex;
    justify-content: center;
    margin-right: 22px;
  }
`;

interface PaymentRowProps {
  title: string;
  img: string;
  meta?: string | React.ReactElement;
  isLast?: boolean;
}

export const PaymentRow = ({
  title = "",
  img = "",
  meta,
  isLast = false,
}: PaymentRowProps) => {
  const { customTheme }: { customTheme: CustomTheme } =
    useContext(ThemeContext);
  const theme: Theme = useTheme();

  return (
    <Container customTheme={customTheme} isLast={isLast}>
      <div className="left">
        <img src={img} />
        <Typography>{title}</Typography>
      </div>
      <div className="right">
        <div className="tools">{meta}</div>
        <Icon name="Circle" color={theme.palette.grey[5]} size="16px" />
      </div>
    </Container>
  );
};
